import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const Container = styled.div`
  padding: 0 24px;

  @media (max-width: 576px) {
    padding: 0;
  }
`

export const PageTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`

export const PageTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const BackButton = styled.div`
  display: flex;
  align-items: center;
  padding-right: 22px;
  padding-left: 14px;
  width: 48px;
  height: 12px;
  cursor: pointer;
`
export const TrackInfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 24px;
  width: 100%;
  height: 111px;
  background-color: ${colors.white};
`

export const TrackInfoContainerMobile = styled.div`
  display: flex;
  margin-bottom: 16px;
  padding: 16px;
  width: 100%;
  background-color: ${colors.white};
`

export const TrackAvatarMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  margin-right: 16px;
`

export const TrackInfoColumnMobile = styled.div``

export const TrackInfoRowMobile = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

export const TrackInfoLabelMobile = styled.span`
  font-size: 10px;
  color: ${colors.mainText};
`

export const TrackInfoTextMobile = styled.span`
  font-size: 14px;
  color: ${colors.mainText};
`

export const SpotifyIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 24px;
  height: 100%;

  @media (max-width: 576px) {
    height: 24px;
  }
`

export const TrackAvatar = styled.img`
  margin-left: 16px;
  width: 40px;
  height: 40px;
  border-radius: 4px;

  @media (max-width: 576px) {
    margin-left: 0;
    margin-bottom: 16px;
  }
`

export const TrackTitleContainer = styled.div`
  margin-left: 16px;
  padding: 2px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 40px;
  flex: 1;
`

export const TrackTitle = styled.h5`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`

export const TrackAuthor = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${colors.mainText};
  line-height: 15px;
`

export const CampaignCalculationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 152px;

  @media (max-width: 576px) {
    margin-bottom: 16px;
  }
`

export const CampaignCalculation = styled.div`
  height: 21px;
`

export const CampaignCalculationLabel = styled.span`
  margin-left: 16px;
  color: ${colors.greyTextWhiteBg};

  @media (max-width: 576px) {
    margin-left: 0;
  }
`

export const CampaignCalculationValue = styled.span<{ green?: boolean }>`
  color: ${({ green }) => (green ? colors.green : colors.mainText)};
`

export const GenresAndLanguagesContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 224px;
`

export const CardsOverflow = styled.div`
  @media (max-width: 576px) {
    position: relative;
    margin-right: 26px;
    width: 100vw;
    overflow-x: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const CardsContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 16px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-x: scroll;

  @media (max-width: 576px) {
    width: 466px;
    margin-right: 26px;
  }
`

export const Card = styled.div`
  width: 24%;
  height: 128px;

  @media (max-width: 576px) {
    margin-bottom: 10px;
    width: 228px;
  }
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 14px 16px;
  background-color: ${colors.white};
  border-radius: 4px;
`

export const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.greyTextWhiteBg};
`

export const CardMainValue = styled.h5`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const CardAdditionalInfo = styled.h5`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.green} !important;
`

export const DataNotReceivedContainer = styled.div`
  display: flex;
  align-items: center;
`

export const DataNotReceivedIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`

export const DataNotReceivedLabel = styled.div`
  margin: 0 0 0 8px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const ConnectSFA = styled.span`
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
  cursor: pointer;
`

export const ConnectedSFAContainer = styled.div`
  display: flex;
`

export const DotConnectedSFA = styled.div`
  margin: 3px 8px 0 0;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${colors.green};
`

export const ConnectedSFA = styled.span`
  color: ${colors.mainText};
  font-size: 10px;
  line-height: 14px;
`

export const TabTitles = styled.div`
  display: flex;
  margin-bottom: 20px;

  @media (max-width: 576px) {
    position: relative;
    width: 100vw;
    overflow-x: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const TabButton = styled.button<{ active: boolean }>`
  overflow: visible;
  background: none;
  border: none;
  font-size: 14px;
  color: ${colors.mainText};
  transition: 0.5s;
  padding: 10px 20px;
  border-bottom: 3px solid
    ${({ active }) => (active ? colors.badgeGreen : colors.greyStroke)};
`

export const TabButtonCount = styled.span<{ green?: boolean; red?: boolean }>`
  margin-left: 8px;
  font-size: 14px;
  color: ${({ green, red }) => {
    if (green) {
      return colors.messegesGreen1
    }
    if (red) {
      return colors.messegesRed
    }
    return colors.greyTextBlackBg
  }};
`

export const ReviewsContainer = styled.div`
  padding: 24px;
  background-color: ${colors.white};

  @media (max-width: 576px) {
    padding: 0;
    background-color: transparent;
  }
`

export const ToggleDetails = styled.span`
  display: inline-block;
  margin-top: 9px;
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};
`
